module.exports = __webpack_public_path__ + "static/media/trim-smart.edf82854.png";